export default {

  // 首页
  专业发电机展示内容: '福安优加动力有限公司成立于2008年，工厂位于福建省福安市，占地25000多平方米，已为 100 多个国家提供 Usuper电力系统设备和优质的服务。',
  柴油发电机组: '柴油发电机组',
  空气压缩机: '空气压缩机',
  灯塔: '灯塔',
  冷藏发电机: '冷藏发电机',
  柴油发电机组desc: '优加动力发电机组系列涵盖7–3260KVA的规格范围，以丰富的经验为依托，根据客户具体使用需求，为客户提供定制化的解决方案。',
  空气压缩机desc: '采用高效率双螺杆压缩主机，满足市政、工业与采矿等多场景需求。结构紧凑，维护便捷，性能稳定可靠。',
  灯塔desc: '多规格LED手动灯车，支持不同高度与照度需求，移动灵活，适用于多种临时照明场景。',
  冷藏发电机desc: '适配各种冷链运输应用，提供稳定可靠的恒温供电方案，确保冷链全程品质。',


  可靠的发电机供应商: '可靠的发电机供应商',
  可靠的发电机供应商desc: '福安优加动力有限公司成立于2008年，是国内注册的一家科技导向型高新技术企业，致力于发电机组、空气压缩机、动力驱动水泵机组、移动照明灯车、冷藏车电气控制系统等产品及相关电气控制系统的技术研发和制造，注册商标“优加动力USUPERPOWER”, 生产基地坐落于福建福安，技术娴熟的装配工人、规范的标准化生产日益提高优加动力的产品质量和生产效率。多年来公司持续投入资金用于技术研发、工艺改进以及生产检测设备。\n' +
    '    公司以“客户至上、追求一流、正道经营、共存共赢”为核心价值观，致力于为客户提供最好的产品和全球服务，成就客户的成功。',
  公司经验: '公司经验',
  厂区: '厂区',
  公司员工: '公司员工',
  合作国家: '合作国家',


  专业发电机展示: '专业发电机展示',
  阅读更多: '阅读更多',
  全面的电源解决方案: '全面的电源解决方案',
  更多: '更多',
  数字展厅: '数字展厅',
  数字展厅desc: '如果您想了解更多我们的制造能力，可以点击场景中的头像，或者接受我的邀请！',
  支持中心: '支持中心',
  支持中心desc: '优加动力以客户为中心，指导他们的所有工作，并拥有一支随时可以应对任何情况的团队。',
  售后流程: '售后流程',
  售后流程desc: '如果使用过程中出现故障，我们将在24小时内及时处理。',
  安装指导: '安装指导',
  安装指导desc: '优加动力可以提供在线实时安装调试咨询和指导。',
  培训: '培训',
  培训desc: '如有需求，我司将安排技术人员进行培训和指导。',
  安全和可持续的实践: '安全和可持续的实践',
  安全和可持续的实践desc: '优加动力科技秉承绿色可持续发展的理念，专注减少环境污染影响，推动绿色能源的应用，为构建可持续的未来做出贡献。',
  博客: '博客',
  查看更多: '查看更多',

  // 行业数据
  case_c1_title: '我公司为加纳工业区新建电力设备厂提供备用发电机组',
  case_c1_p1: '项目背景：加纳阿克拉工业区正在建设一座现代化电力设备制造厂，该厂为当地电力配套产业的重要组成部分。为保障厂区生产设备在供电波动情况下的正常运行，我公司为该项目提供了整套备用柴油发电机组系统。',
  case_c1_p2: '本项目共采用3台主用功率600KW、备用功率660KW的发电机组，具备远程监控及自动切换功能。设备目前已完成交付并进入系统联调阶段。',
  case_c1_p3: '项目建设过程中，我公司凭借丰富的国际工程经验和完善的售后体系，为客户提供了从方案设计到现场调试的一体化服务，确保了厂区供电系统的高效、安全与稳定运行，为加纳本地制造业发展贡献力量。',
  case_c2_title: '我公司为加纳某大型金矿项目提供高性能发电机组',
  case_c2_p1: '项目背景：加纳西部地区某大型金矿项目是当地矿业发展的重点工程，对供电的连续性与稳定性要求极高。为确保矿山生产及安全系统的稳定运行，该项目采用了我公司提供的柴油发电机组。',
  case_c2_p2: '本次项目中，我公司共向业主单位交付6台柴油发电机组，单机主用功率800KW，备用功率880KW。目前，设备已全部抵达项目现场并进入调试安装阶段。',
  case_c2_p3: '项目自今年初启动以来，面对加纳雨季施工条件复杂、电力供应紧张等挑战，我公司技术团队积极配合现场建设进度，提供专业的安装与售后支持，确保项目顺利推进。我们的高性能发电机组凭借卓越的可靠性与适应性，赢得了业主及施工方的高度评价。',
  case_c3_title: '我公司为尼日利亚北部农业加工园区提供柴油发电机组',
  case_c3_p1: '项目背景：加纳北部农业加工园区是当地政府重点扶持的现代化产业集群项目，旨在推动农产品深加工与出口贸易。为满足园区生产及冷链仓储的稳定供电需求，我公司提供了多台柴油发电机组，确保项目在不稳定电网环境下依然高效运转。',
  case_c3_p2: '本次供货包括4台主用功率400KW、备用功率440KW的高效节能型柴油发电机组。设备自运抵现场以来，我公司工程师团队全程参与安装与调试，确保系统安全投入使用。',
  case_c3_p3: '项目建成后，园区将大幅提升加纳农产品加工能力，为当地经济与就业发展注入新动能。该项目的顺利推进，标志着我公司在非洲市场的技术实力与品牌影响力进一步提升。',

  // 博客
  news_n1_title: '优加动力在加纳阿克拉成立分公司，深化非洲市场布局',
  news_n1_h2: '优加动力——以可靠动力点亮世界',
  news_n1_p1: '优加动力（USUPERPOWER）已在加纳首都阿克拉正式设立分公司，这是公司全球化发展战略的重要一步，标志着优加动力在非洲市场的业务布局进一步深化。\n\n作为一家专注于发电机组及电力设备制造的企业，优加动力始终以创新驱动发展，以高效、可靠的产品和优质服务赢得全球客户信赖。非洲地区对高性能发电设备的需求日益增长，为更好地满足当地市场，优加动力加纳分公司应运而生。\n\n新设立的加纳分公司位于阿克拉核心工业区，配备专业的技术服务与销售团队，并设有备件仓储和售后支持中心，可为客户提供更及时的产品交付、技术指导、维护培训及配件供应。通过本地化运营，优加动力能够更快速地响应客户需求，提升服务效率与市场竞争力。\n\n优加动力负责人表示，加纳分公司的建立，不仅将更好地服务加纳本地客户，也将辐射西非周边国家，包括尼日利亚、科特迪瓦、塞内加尔等区域市场。未来，公司还计划在非洲逐步建立展示中心与技术培训基地，推动清洁能源与高效电力解决方案的本地化应用。\n\n凭借十余年的制造经验与全球销售网络，优加动力的发电机组产品已广泛应用于矿业、建筑、电力工程、通信及应急供电等领域。此次加纳分公司的成立，进一步体现了优加动力“立足中国、服务全球”的企业愿景。',
  // Header
  header_电话: '电话',
  header_电子邮件: '电子邮件',
  header_搜索: '搜索',
  header_搜索placeholder: '搜索...',
  header_获取报价: '获取报价',

  // Footer
  footer_电话: '电话',
  footer_邮箱: '邮箱',
  footer_快速链接: '快速链接',
  footer_产品类别: '产品类别',
  footer_立即联系我们: '立即联系我们！',
  footer_电子邮件placeholder: '*电子邮件',
  footer_姓名: '姓名',
  footer_电话placeholder: '*电话',
  footer_信息: '信息',
  footer_提交: '提交',
  footer_版权: '版权 © 2025 厦门固泰力动力科技有限公司 保留所有权利。 闽ICP备17025355号-1',

  // 通用导航
  首页: '首页',
  产品: '产品',
  行业: '行业',
  支持: '支持',
  售后服务: '售后服务',
  关于我们: '关于我们',
  公司简介: '公司简介',
  证书展示: '证书展示',
  可持续发展: '可持续发展',
  联系我们: '联系我们',
  燃气发电机组: '燃气发电机组',
  移动照明灯车: '移动照明灯车',
  电焊机: '电焊机',
  其他的: '其他的',

  // Product 页面
  产品类别: '产品类别',
  电焊机组: '电焊机组',
  气体发电机: '气体发电机',
  breadcrumb_当前位置: '当前位置：',
  product_primary_diesel_desc: '隔音发电机驱动焊机配备了专为焊接设计的异步交流发电机。',
  product_primary_compressor_desc: '为多场景提供稳定压缩空气，结构紧凑、维护便捷、性能稳定。',
  product_sec_welder_desc: '隔音发电机驱动焊机配备了专为焊接设计的异步交流发电机。',
  product_sec_gasgen_desc: '采用天然气、沼气等清洁能源，经济环保、维护成本低。',
  product_sec_tower_desc: '这些灯塔可覆盖高达6836平方米的照明面积，连续工作近4天。',
  product_sec_reefer_desc: '为冷链运输提供稳定可靠的恒温供电方案。',

  // Category 页面
  category_筛选: '筛选',
  category_功率KVA: '功率 (KVA)：',
  category_请选择: '请选择',
  category_发动机品牌: '发动机品牌：',
  category_频率HZ: '频率 (HZ)：',
  category_搜索: '搜索',
  category_重置: '重置',
  询问: '询问',
  柴油驱空压机: '柴油驱空压机',
  电驱空压机: '电驱空压机',
  'EPA 等级 T4F': 'EPA 等级 T4F',
  欧盟第三阶段: '欧盟第三阶段',
  欧盟第五阶段: '欧盟第五阶段',
  国标三阶段: '国标三阶段',
  category_table_型号: '型号',
  category_table_备用KVA: '备用 (KVA)',
  category_table_备用KW: '备用 (KW)',
  category_table_常用KVA: '常用 (KVA)',
  category_table_常用KW: '常用 (KW)',
  category_table_发动机品牌: '发动机品牌',
  category_table_发动机型号: '发动机型号',
  category_table_静音型: '静音型',
  category_table_拖车型: '拖车型',
  category_table_排放: '排放',
  category_table_下载: '下载',

  // Service 页面
  service_报修说明: '如果您购买了任何一台优加动力产品，在使用过程中出现任何故障或需要技术支持，您可以通过以下方式进行报修，我们将在24小时内及时响应与处理。',
  service_报修方式: '报修方式',
  service_报修方式desc: '请先找到优加动力设备铭牌，扫描设备上的售后二维码，或登录优加动力售后服务网站。填写售后申请表后，我们的售后团队将第一时间与您联系并提供解决方案。',
  service_维修与技术支持: '维修与技术支持',
  service_维修与技术支持desc: '无论您的设备安装在何地，优加动力都将为您提供专业、快捷的维修与技术服务。我们为每一位客户建立专属档案，定期进行巡检与维护，必要时可提供现场技术支持及远程指导。此外，我们可根据客户需求制定个性化维护计划，并配备原厂备件，保障设备长期高效运行。',
  service_品质与保修承诺: '品质与保修承诺',
  service_品质与保修承诺desc: '优加动力产品实行“三包”政策和终身服务制度。具体保修条款请参考产品随附的保修手册。所有客户均可享受以下服务保障：',
  service_保障1: '提供合格、完整的产品与技术资料；',
  service_保障2: '提供设备安装、调试及操作指导；',
  service_保障3: '安排专业技术人员培训；',
  service_保障4: '建立客户档案并定期回访；',
  service_保障5: '提供原厂正品零配件；',
  service_保修期限: '保修期限',
  service_保修期限desc: '保修期限以发货时间、购买时间、使用时间三者中最早发生者为准：',
  service_保修A: 'A. 使用时间：自首次运行起1000小时；',
  service_保修B: 'B. 购买时间：自设备到达客户之日起12个月；',
  service_保修C: 'C. 交货时间：自出厂发货之日起15个月。',
  service_快速响应: '快速响应',
  service_快速响应desc: '优加动力售后团队在接到报修后，将在最短时间内完成问题诊断、备件更换与现场调试，确保设备快速恢复运行状态。',
  service_联系我们desc: '如有售后问题，请联系当地优加动力授权经销商，或直接拨打客户服务热线：0591-22970811 电子邮件：sales@jdlpower.com',
  service_安装与培训服务: '安装与培训服务',
  service_安装与培训服务desc1: '客户收到货物后，优加动力可提供在线安装指导及实时调试支持，或派遣经验丰富的工程师前往现场进行安装、调试与性能测试。',
  service_培训服务intro: '我们还为客户提供多种形式的培训服务：',
  service_工厂实训: '工厂实训',
  service_在线视频培训: '在线视频培训',
  service_现场操作培训: '现场操作培训',
  service_培训安排示例: '培训安排示例：',
  service_第一次培训: '第一次培训：针对安装人员，内容包括设备结构原理、安装调试方法、操作规范及安全事项。',
  service_第二次培训: '第二次培训：针对运行管理人员，内容包括设备维护保养、电机常见故障诊断及柴油机组使用管理等。',
  service_服务结语: '优加动力始终以客户满意为中心，致力于为每一位用户提供高效、可靠的售后服务保障，让每一台设备都能保持最佳运行状态。',

  // About Us 页面
  行业经验: '行业经验',
  全球市场: '全球市场',
  生产能力: '生产能力',
  研发与制造: '研发与制造',
  台月: '台/月',
  aboutus_company_intro: '福安优加动力有限公司（USUPERPOWER）成立于2008年，是一家专业从事柴油发电机、超静音发电机、水泵发电机组、燃气发电机组研发、生产与销售的高新技术企业。同时，公司也积极拓展移动照明灯塔、空气压缩机等新型动力设备的开发与制造。\n公司位于福建省宁德市下辖的福安市，占地面积超过25,000平方米，环境优美整洁，生产设施先进完善。我们秉承“严格管理、勇于创新、顾客满意、争创品牌”的经营理念，通过持续改进工艺和管理，不断提升产品品质与制造水平。\n公司配备了国际先进的全自动激光切割机、数控折弯机等现代化设备，并采用优质原材料与科学工艺流程，确保每一台产品都具有卓越的性能与可靠的品质。凭借多年的设计、制造和调试经验，我们为全球客户提供高效、稳定的电力系统解决方案与国际化服务。\n优加动力在加纳设有分公司，负责当地的配件供应与售后支持。同时，我们已在美国、澳大利亚、法国、印度尼西亚、巴勒斯坦、尼日利亚、委内瑞拉、菲律宾、马来西亚、新加坡等多个国家建立了长期合作伙伴与代理商。\n目前，公司产品已远销全球100多个国家和地区，为世界各地提供USUPER品牌的发电设备与优质服务，赢得了广泛的市场认可与良好的品牌声誉。\n优加动力将一如既往，以可靠的品质、领先的技术和专业的服务，为全球客户持续提供安全、高效、绿色的动力支持。',
  aboutus_rd_desc: '优加动力经过多年技术积累与持续投入，现已建立完善的研发体系和专业技术开发平台。公司拥有一支经验丰富、专业过硬的工程技术团队，具备强大的自主研发与制造能力，在行业细分领域中保持领先的创新水平。我们不断优化设计、改进工艺，为各种复杂环境和严苛应用场景提供高品质、可靠耐用的电力设备。同时注重人性化设计，使设备的维护与保养更加高效便捷。目前，优加动力的产品已出口至亚洲、欧洲、非洲及南美洲等50多个国家和地区。\n公司多学科工程师团队专注于发电机组组件的持续改进，从工业外观、结构优化到材料工艺与生产流程，全面提升设备的运行效率与隔音性能。\n这些技术优化使发动机在更理想的条件下运行，提升燃烧效率，减少废气、热量与噪音排放，同时显著延长发电机组的使用寿命。\n优加动力的控制系统均由公司自主设计与生产，每一套配置均采用优选元件并经过严格质检。我们能够根据客户需求定制不同的运行模式，无论是独立供电还是并网运行，都能确保系统的稳定、高效与安全。',

  // Certificate 页面
  certificate_intro: '优加动力始终以客户为中心，所有工作都以客户需求为出发点，并拥有一支能够迅速响应、专业高效的技术与服务团队。我们的产品具备噪音低、振动小、操作简便、性能稳定可靠等特点，所有产品都符合CE及ISO 9001国际质量标准。\n凭借17年以上的行业经验，优加动力的业务已覆盖全球五大洲、100多个国家。我们具备灵活完善的制造能力，能够从标准化产品到高端定制方案全面满足客户需求，广泛应用于石油天然气、矿业、电力建设及工程项目等领域，满足对复杂环境和高性能要求的多种应用场景。\n立足行业前沿，优加动力致力于成为中国动力设备领域的代表性品牌，以创新和品质为核心驱动力，不断超越自我，为全球客户创造更持久、更可靠的价值。',

  // Sustainability 页面
  sustain_hero_title: '可持续发展',
  sustain_lead_intro: '优加动力可持续发展理念\n优加动力作为一家专业的发电机组研发与制造企业，始终坚持绿色、健康、可持续的发展理念。我们在提供高效可靠的电力解决方案的同时，积极探索降低能耗与环境影响的技术路径，以创新驱动能源转型，为构建可持续的未来贡献力量。',
  sustain_lead_env_product: '环保产品\n优加动力的柴油发电机组、燃气发电机组、冷藏发电机和照明灯塔等系列产品在设计阶段即融入环保理念。我们通过先进的燃烧控制与节能技术，最大限度地减少废气排放与噪音污染，确保产品在高性能运行的同时实现更低的生态足迹。',
  sustain_lead_energy_efficiency: '高效能源\n我们的发电设备以卓越的能源利用率著称。通过优化动力系统与控制技术，优加动力帮助客户在减少燃油消耗与碳排放的同时，降低运营成本，提升能源使用效率，实现经济与环保的双重价值。',
  sustain_lead_safety: '安全与合规\n优加动力严格遵循国际及地区安全标准，对所有产品进行全面检测与性能验证，确保其在不同环境与行业中的可靠性与安全性。我们所有设备均符合或优于相关法规与质量认证要求。',
  sustain_lead_environment_responsibility: '环境责任\n我们深知制造环节对环境的潜在影响，因此优加动力在生产全过程中推行绿色制造体系，尽量采用可回收材料、优化能源使用、减少废弃物排放。公司还持续改进生产工艺，以实现产品全生命周期的环保目标。',
  sustain_lead_social_responsibility: '社会责任\n优加动力积极参与当地社区与环保公益项目，推动清洁能源知识的普及与应用。我们坚信企业的发展应与社会、环境共同进步，并致力于成为发电机行业内可持续发展的典范。',
  sustain_btn_aboutus: '了解更多关于我们公司的信息',

  sustain_feature_env_product_title: '环保产品',
  sustain_feature_env_product_desc: '我们的柴油发电机组、燃气发电机、冷蕴发电机、空气压缩机和环塔在设计时充分考虑了环境。我们利用先进技术确保我们的产品具有最小的生态足迹，减少排放并节约资源。',
  sustain_feature_efficiency_title: '效率和性能',
  sustain_feature_efficiency_desc: '固泰力产品专为实现最佳能源效率而设计，确保我们的客户能够以更低的能源消耗和碳排放来运营。这不仅有利于环境，还可以为我们的客户节省成本。',
  sustain_feature_safety_title: '安全与合规',
  sustain_feature_safety_desc: '我们遵守行业最高的安全标准。我们的产品经过严格测试，满足或超过监管要求，确保它们可以更安全地用于各种应用。',
  sustain_feature_environment_title: '环境责任',
  sustain_feature_environment_desc: '固泰力致力于在产品的整个生命周期中尽量减少对环境的影响。我们实施减少废物战略，使用可持续材料，并促进制造过程中回收利用。',
  sustain_feature_social_title: '社会承诺',
  sustain_feature_social_desc: '除了我们的产品之外，固泰力还积极参与社区发展和环境保护工作。我们坚信回馈社会和地球的福祉并为其做出贡献。',
  sustain_feature_conclusion_desc: '作为一家公司，固泰力很自豪能够成为可持续发展领域的领导者，我们期待继续迈向更绿色、更健康的世界。',
  sustain_feature_more_btn: '了解更多我们的产品',

  // Contact Us 页面
  contact_intro1: '请立即联系我们获取报价或询问有关我们服务的问题。填写并提交表格后，我们将在 24 小时内与您联系。',
  contact_intro2: '也请随时通过电话与我们联系。在正常工作时间，总会有人接听您的电话。',
  contact_label_address: '地址',
  contact_address_value: '中国福建省福安市罗江工业路88号',
  contact_label_email: '电子邮件',
  contact_label_phone: '电话',
  contact_label_whatsapp: 'WhatsApp',
  contact_phone_value: '0591-22970811',
  contact_whatsapp_value: '18950074022',
  contact_form_title: '立即联系我们！',

  // 通用
  品牌名: '优加动力',


  公司新闻: '公司新闻',
  产品知识: '产品知识',
  knowledge_title: '多电压机组的配置及市场应用',
  knowledge_desc1: '多电压发电机组配置\n' +
      '1.1 多电压发电机组概述\n' +
      '由于发电机组应用的功率要求不同或者用户终端负载的输入电源电压的多样性，此时就需要具有多电压交流电源输出的发电机组。',
  knowledge_desc2: '优加动力 1500KW/220V 3P/4W--380V 3P 4W 多电压发电机组\n' +
      '1.2 多电压输出发电机组的分类\n' +
      'a.小功率部分的负载方式可以通过通用转换开关来实现。这种方式可以支持3种不同电压的切换。\n' +
      'b.现场有专业发电机组电气维修人员的用户可选择手动改装。可以通过改变铜排的连接点来实现，该方法可以支持3种不同电压的变化。\n' +
      'c.可选应用双电源开关，通过改变发电机绕组接线方式，实现电压的自动切换。该方法可以支持2种不同电压的切换。\n' +
      '\n' +
      '万能转换手动切换方式 手动改变铜母线方式 双电源切换改变绕组接线\n' +
      '\n' +
      '1.3 多电压发电机组的配置\n' +
      '\n' +
      'A、万能转换手动切换方式：发电机组主断路器（额定电流按最小电压段和最小相数计算）、万能转换开关、主断路器至万能转换开关及万能转换开关至发电机连接电缆，控制系统具有多种电压特性保护、AVR接线调节。\n' +
      '\n' +
      'B、手动换铜母线方式：发电机组主断路器（额定电流按最小电压段和最小相数计算）、各种电压切换绝缘板、主断路器绝缘板及绝缘板至发电机连接电缆，控制系统具有多种电压特性保护，AVR接线调整\n' +
      '\n' +
      'C.双电源切换改变绕组接线方式：发电机组主断路器（额定电流按最小电压段和最小相数计算）、2个双电源开关及其控制元件、主断路器至双电源开关及双电源开关至发电机的连接电缆，控制系统具有多种电压特性保护、AVR接线调整。\n' +
      '\n' +
      '1.4 多电压发电机组发电机选型要求\n' +
      '\n' +
      '各种电压切换的工作原理：由于12线发电机绕组可以调节，根据发电机绕组接线原理图，可以输出： 1、串联星形绕组接线输出：380V-415V/50Hz和380V-480V /60HZ；2.并联星形绕组接线输出：190V-208V/50HZ 和190V-240V/60HZ：双三角形绕组接线输出：220V-240V/50HZ 和220V-240V/60HZ。',
  knowledge_desc3: '各种电压发电机组的发电机选型要求：\n' +
      '1、发电机组绕组需要12线输出； 2、AVR需要有电压微调电位器信号输出。\n' +
      '1.5 多电压发电机组的市场应用场景 多电压发电机组的市场应用： 1．发电机组租赁市场；\n' +
      '2、用户终端设备的电源输入电压多种多样；\n' +
      '3、用户终端设备有单相负载和三相负载，但不同时使用；\n' +
      '4、各国电网输出电压不同。',
}
